import { differenceInCalendarDays, startOfISOWeek } from 'date-fns'

/* Grades */
export const DEFAULT_GRADE = (realmId: number) => {
  return realmId === 2 ? 'Competition' : 'Grade'
}
export const DEFAULT_GRADE_SELECT = (realmId: number) => {
  return `All ${DEFAULT_GRADE(realmId)}s`
}

/* Dates */
export const STARTING_DATE = new Date()
export const MAX_WEEKS_DISPLAY = 6
export const MAX_WEEKS_DISPLAY_IN_DAYS =
  7 * MAX_WEEKS_DISPLAY - differenceInCalendarDays(STARTING_DATE, startOfISOWeek(STARTING_DATE)) - 1
export const PAST_YEARS_IN_STREAM_HISTORY = 30
export const FUTURE_HOURS_IN_DASHBOARD = 12
export const AWAY_TEAM_SCHEDULE_LOCKOUT_DAYS = 3
export const SHORT_YEAR_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/* Streams / StreamConfigs */
export const STREAM_AUTO_START_MINS = 60
export const STREAM_TITLE_LENGTH = [1, 100]
export const STREAM_DESCRIPTION_LENGTH = [1, 500]
export const STREAM_TEAM_NAME_LENGTH = [1, 50]
export const STREAM_TEAM_SHORTNAME_LENGTH = [2, 5]

/* External Links */
export const HELP_REQUEST_LINK = 'https://frogbox.freshdesk.com/support/tickets/new'
export const HELP_TROUBLESHOOT_LINK = 'https://frogbox.freshdesk.com/support/solutions'

/* Datadog */
export const DATADOG_IGNORED_ERRORS = [
  'Uncaught "Script error."',
  'Failed to load FreshChat SDK: Error: Failed to load script',
  'Error: Script error.',
  'Uncaught "Object Not Found Matching Id',
  'Temporary password has expired and must be reset by an administrator',
  'Incorrect username or password',
  'UserNotFoundException: User does not exist.',
  'VIDEOJS: ERROR: TypeError: Cannot read properties of undefined',
]
